import { Outlet } from 'react-router-dom';

export const ZoneOutlet = () => <Outlet />;
